'use strict';

var base = require('./base');
var detail = require('base/product/detail');
var quickView = require('./quickView');

detail.availability = base.availability;
detail.focusChooseBonusProductModal = base.focusChooseBonusProductModal();
detail.quickViewRedirectToPdp = quickView.redirectToPdp;
detail.quickViewShowQuickAddButton = quickView.showQuickAddButton;
detail.quickViewFlipImage = quickView.flipImage;

// Store pending add-to-cart data
var pendingAddToCartButton = null;

/**
 * Add the confirmation modal element to the body and show it
 * @param {Object} data - Data object containing the rendered template
 * @param {string} data.renderedTemplate - Rendered template HTML
 * @returns {void}
 */
function addConfirmationModalElement(data) {
    if ($('#addToCartConfirmationModal').length !== 0) {
        $('#addToCartConfirmationModal').remove();
    }
    $('body').append(data.renderedTemplate);

    $('#addToCartConfirmationModal').modal('show');
    $('body').trigger('addToCartConfirmationModal:ready');
}

/**
 * Override addToCart to check for short shelf life first
 * @returns {void}
 * @description This function overrides the addToCart function to check for short shelf life first.
 * If the product has short shelf life, it will show the confirmation modal.
 * If the product does not have short shelf life, it will proceed with the add to cart.
 * If the product has short shelf life and the user confirms the add to cart, it will proceed with the add to cart.
 * If the product has short shelf life and the user does not confirm the add to cart, it will not proceed with the add to cart.
 * @param {Event} e - The event object
 * @param {jQuery} $button - The button element
 */
detail.addToCart = function () {
    $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function (e) {
        var $button = $(this);

        // If already confirmed, skip the check and let it proceed
        if ($button.data('confirmed')) {
            $button.removeData('confirmed');
            return true;
        }

        var pid = base.getPidValue($button);
        var isShortShelfLife = $button.data('is-short-shelf-life');

        // Check if we need to fetch short shelf life status
        if (isShortShelfLife === undefined || isShortShelfLife === true) {
            e.stopImmediatePropagation();
            pendingAddToCartButton = $button;

            $.ajax({
                url: $button.data('short-shelf-life-url'),
                type: 'GET',
                data: { pid: pid },
                success: function (response) {
                    // add data attributes for non-short shelf life products only
                    if (response.isShortShelfLife !== true) {
                        $button.data('is-short-shelf-life', false);
                        $button.data('confirmed', true);
                        $button.trigger('click');
                    } else {
                        // Show confirmation modal for short shelf life products
                        addConfirmationModalElement(response);
                    }
                },
                error: function () {
                    // On error, allow add to cart to proceed
                    $button.data('confirmed', true);
                    $button.trigger('click');
                }
            });
            return false;
        }

        // If not short shelf life (cached as false), let base handler process
        return true;
    });

    base.addToCart();
};

/**
 * Handle the add to cart confirmation modal button click
 */
detail.confirmAddToCart = function () {
    $('body').on('click', '#addToCartConfirmationModal .confirm-add-to-cart', function () {
        if (pendingAddToCartButton) {
            pendingAddToCartButton.data('confirmed', true);
            pendingAddToCartButton.trigger('click');
            pendingAddToCartButton = null;
        }
        $('#addToCartConfirmationModal').modal('hide');
    });
};

/**
 * Handle the add to cart confirmation modal close
 */
detail.closeConfirmationModal = function () {
    $('body').on('click', '#addToCartConfirmationModal', function (e) {
        if (e.target === this) {
            $(this).modal('hide');
            pendingAddToCartButton = null;
        }
    });
};

detail.updateAddToCart = function () {
    $('body').on('product:updateAddToCart', function (e, response) {
        var enable = $('.product-availability').toArray().every(function (item) {
            return $(item).data('available') && $(item).data('ready-to-order');
        });

        var product = response && response.product ? response.product : null;
        if (product) {
            enable = product.available && product.readyToOrder;
        }

        // Update button disabled state and text
        var $addToCartBtn = $('button.add-to-cart, button.add-to-cart-global');
        if (enable) {
            $addToCartBtn.prop('disabled', false).removeClass('disabled');
            if (product && product.buttonText) {
                $addToCartBtn.text(product.buttonText);
            }
        } else {
            $addToCartBtn.prop('disabled', true).addClass('disabled');
            if (product && product.buttonText) {
                $addToCartBtn.text(product.buttonText);
            }
        }
        module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
    });
};

// Quantity selector stepper buttons
detail.quantitySelector = function () {
    // Handle the quantity stepper buttons
    $(document).on('click', '.qty-btn', function () {
        const $wrapper = $(this).closest('.quantity-stepper');
        const $input = $wrapper.find('.quantity-select');

        const min = parseInt($input.attr('min'), 10) || 1;
        const max = parseInt($input.attr('max'), 10) || 50;
        let value = parseInt($input.val(), 10) || min;
        let tempValue = value;

        if ($(this).hasClass('qty-plus') && value < max) {
            value += 1;
        }

        if ($(this).hasClass('qty-minus') && value > min) {
            value -= 1;
        }

        if (value !== tempValue) {
            $input.val(value).trigger('change');
        }
    });

    /* Manual typing validation */
    $(document).on('change', '.quantity-select', function () {
        const $input = $(this);
        const min = parseInt($input.attr('min'), 10) || 1;
        const max = parseInt($input.attr('max'), 10) || 50;
        let value = parseInt($input.val(), 10);

        if (Number.isNaN(value)) {
            value = min;
        } else if (value < min) {
            value = min;
        } else if (value > max) {
            value = max;
        }
    });
};

module.exports = detail;
